

export default class LoginDeufaultPlugin {

    name = 'defaultPlugin'

   init = ()=>{
       
   }

    willLogin = (params,callback) =>{   
        callback(params) ;
    }

}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/util/plugin/loginDeufaultPlugin.js